import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={17} height={17} viewBox="0 0 16.463 16.463" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7.08 15.312v-5.93H1.15a1.15 1.15 0 110-2.301h5.93V1.15a1.15 1.15 0 112.302 0v5.93h5.93a1.15 1.15 0 110 2.3h-5.93v5.931a1.15 1.15 0 11-2.301 0z" fill="currentColor" /></svg>;
}
export default SvgComponent;